import React from "react";
import Headline from "./Headline";
import Postcards from '../../components/shared/Postcards';
import HomeLink from "../../widgets/HomeLink";
import AlbumsApi from "../../api-services/albums-api.service";
import { notification } from "antd";

const bannerPath = '/iceholidays-assets/images/gallery_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Gallery' }
]


export default class GalleryPage extends React.Component {
  api = new AlbumsApi;

  state = {
    albums: []
  }

  componentDidMount() {
    this.api.getAlbums()
    .then(albums => {
      this.setState({albums})
    })
    .catch(error => {
      notification.error({ message: 'An error occured while loading albums.'});
    });
  }


  render(){
    return (
      <div id="gallery" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            Gallery
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          <Postcards items={this.state.albums} link="gallery/"/>
        </div>

      </div>
    )
  }
}